import { createRequest, RequestConfig } from '../../core/libs/api';

export type Feedback = {
  id: number;
  orderId: number;
  date: string;
  rating: number;
  description?: string;
};

export type NewFeedback = Pick<Feedback, 'rating' | 'description' | 'orderId'>;

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/add_order_feedback',
};

export const addOrderFeedback = (feedback: NewFeedback) =>
  createRequest({
    url: config.url,
    body: JSON.stringify(feedback),
    method: config.method,
  });
